<template>
	<div class="page">
		<ul uk-tab class="uk-margin-remove-top uk-margin-small" id="notificationTab">
			<li class="uk-active" @click="resetPreview"><a
				href="#">{{ action === 'edit' ? $t('edit.email.notification') : $t('new.email.notification') }}</a></li>
			<li id="schedulerTab" @click="resetPreview"><a href="#">{{ $t('scheduler.settings') }}</a></li>
			<li v-if="templateId" @click="getPreview">
				<a href="#preview">
					{{ $t('preview.template') }}
					<div v-if="preloader" class="spinner-border" role="loading"></div>
				</a>
			</li>
		</ul>

		<ul class="uk-switcher uk-margin">
			<li class="uk-active">
				<div class="modal_item">
					<label for="notification_name">{{ $t('name') }}</label>
					<br>
					<input id="notification_name" class="textInput attribute-editor" type="text">
					<button class="button_reset fa fa-times"></button>
				</div>
				<div class="modal_item">
					<label>{{ $t('subject') }}</label>
					<br>
					<input id="notification_subject" class="textInput attribute-editor" type="text">
					<button class="button_reset fa fa-times"></button>
				</div>
				<div class="modal_item">
					<label>{{ $t('event.type') }}</label>
					<br>
					<select id="notification_event" class="select attribute-editor"></select>
				</div>
				<div class="modal_item">
					<label>{{ $t('item.status') }}</label>
					<br>
					<div id="notification_status"></div>
				</div>

				<template v-if="action === 'edit'">
					<div class="modal_item">
						<label>{{ $t('send.to.users') }}</label>
						<div class="multicheckbox-filter">
							<div tabindex="0" class="attribute-editor mcb-drop-down-wrapper">
								<div class="mcb-drop-down-btn fa fa-list-ul"></div>
								<div class="value-list">{{ generateValueList(users) }}</div>
							</div>
							<div class="mcb-item-list" ref="users">
								<div class="mcb-controls">
									<div class="mcb-clear blank" tabindex="0"></div>
									<input class="mcb-search" type="text">
									<button class="button_reset fa fa-times" tabindex="-1"
											@click="resetMulticheckbox('users')"></button>
								</div>
								<ul class="checkbox-list" data-name="users">
									<li v-for="user in users" :key="user.id" :class="user.class"
										@click="setMulicheckboxValues(user.id, 'selectedUsers')">
										<input class="attribute-editor bg-editor" :checked="user.checked"
											   type="checkbox" :value="user.id"/>{{ user.login }}
									</li>
								</ul>
								<ul class="checkbox-sublist"></ul>
							</div>
						</div>
					</div>
					<div class="modal_item">
						<label>{{ $t('send.to.user.groups') }}</label>
						<div class="multicheckbox-filter">
							<div tabindex="0" class="attribute-editor mcb-drop-down-wrapper">
								<div class="mcb-drop-down-btn fa fa-list-ul"></div>
								<div class="value-list">{{ generateValueList(groups) }}</div>
							</div>
							<div class="mcb-item-list" ref="groups">
								<div class="mcb-controls">
									<div class="mcb-clear blank" tabindex="0"></div>
									<input class="mcb-search " type="text">
									<button class="button_reset fa fa-times" tabindex="-1"
											@click="resetMulticheckbox('groups')"></button>
								</div>
								<ul class="checkbox-list" data-name="groups">
									<li v-for="group in groups" :key="group.id" :class="group.class"
										@click="setMulicheckboxValues(group.id, 'selectedGroups')">
										<input class="attribute-editor bg-editor" :checked="group.checked"
											   type="checkbox" :value="group.id"/>{{ group.name }}
									</li>
								</ul>
								<ul class="checkbox-sublist"></ul>
							</div>
						</div>
					</div>
				</template>

				<div class="modal_item">
					<label>{{ $t('body.template') }}</label>
					<br>
					<select id="notification_templateId" class="select attribute-editor" v-model="templateId">
						<option v-for="template in templates" :key="template.id" :value="template.id">{{
								template.name
							}}
						</option>
					</select>
				</div>
				<div class="modal_item">
					<label>{{ $t('attachment.template.config') }}</label>
					<br>
					<select id="notification_exportConfigId" class="select attribute-editor"></select>
				</div>
			</li>
			<li>
				<div class="modal_item" id="notification_cronExpression">
					<div class="cron-expression-wrapper" @change="cronExpressionHandler">
						<div>
							<div class="days-wrapper" :style="{
									'background-color': type === 'RAW' ? '#f5f5f5' : ''
									}">
								<label>{{ $t('days.of.week') }}</label>
								<div v-for="(day, key) in days" class="days-item">
									<input type="checkbox" :id="key" v-model="days[key]" :disabled="type === 'RAW'">
									<label :for="key">{{ $t(key) }}</label>
								</div>
							</div>
							<div class="once-wrapper">
								<input name="type" type="radio" id="once" value="ONCE" v-model="type">
								<label class="label-radio" for="once">{{ $t('every.day.at') }}</label>
								<div class="once-expression" :style="{
									'background-color': type !== 'ONCE' ? '#f5f5f5' : ''
									}">
									<div class="expression">
										<label>{{ $t('hours') }}</label>
										<input type="number" min="0" max="23" v-model="hours"
											   :disabled="type !== 'ONCE'">
									</div>
									<div class="expression">
										<label>{{ $t('minutes') }}</label>
										<input type="number" min="0" max="59" v-model="minutes"
											   :disabled="type !== 'ONCE'">
									</div>
								</div>
							</div>
							<div class="interval-wrapper">
								<input name="type" type="radio" id="interval" value="INTERVAL" v-model="type">
								<label class="label-radio" for="interval">{{ $t('period') }}</label>
								<div class="interval-expression" :style="{
									'background-color': type !== 'INTERVAL' ? '#f5f5f5' : ''
									}">
									<div class="expression">
										<label>{{ $t('since') }}</label>
										<input type="number" min="0" max="23" v-model="hoursBegin"
											   :disabled="type !== 'INTERVAL'">
									</div>
									<div class="expression">
										<label>{{ $t('to') }}</label>
										<input type="number" min="0" max="23" v-model="hoursEnd"
											   :disabled="type !== 'INTERVAL'">
									</div>
									<span>{{ $t('hours.every') }}</span>
									<div class="expression">
										<label for="minutesPeriod">{{ $t('minutes') }}</label>
										<select id="minutesPeriod" name="minutesPeriod" :disabled="type !== 'INTERVAL'"
												v-model="minutesPeriod">
											<option value="15">15</option>
											<option value="30">30</option>
											<option value="60">60</option>
											<option value="120">120</option>
											<option value="240">240</option>
											<option value="360">360</option>
										</select>
									</div>
								</div>
							</div>
							<div class="raw-wrapper">
								<input name="type" type="radio" id="raw" value="RAW" v-model="type">
								<label class="label-radio" for="raw">{{ $t('event.cron.expression') }}</label>
								<div class="raw" :style="{
									'background-color': type !== 'RAW' ? '#f5f5f5' : ''
									}">
									<input class="textInput attribute-editor" type="text" v-model="expression"
										   :disabled="type !== 'RAW'">
									<button class="button_reset fa fa-times"></button>
								</div>
							</div>
						</div>
					</div>
					<span :class="error ? 'error' : 'success'">{{ error ? error : nextLaunch }}</span>
				</div>
			</li>
			<li id="preview">
				<div class="preview_frame">
					<iframe :src="'data:text/html,' + htmlPreview" :srcdoc="htmlPreview" width="100%" height="500px"
							sandbox></iframe>
				</div>
				<p class="preview_info">{{ $t('preview.info') }}</p>
			</li>
		</ul>
	</div>
</template>

<script>

import { getFormattedDateTime, getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { USER_GROUP } from 'actions/user'
import {
	enableMulticheckboxSupport
} from '@/core/input_controls/multicheckbox/multicheckbox'
import http from 'utils/http'

function initialState () {
	return {
		days: {
			'monday': true,
			'tuesday': true,
			'wednesday': true,
			'thursday': true,
			'friday': true,
			'saturday': false,
			'sunday': false
		},
		hours: 8,
		minutes: 0,
		hoursBegin: 0,
		hoursEnd: 0,
		minutesPeriod: 15,
		expression: '* 30 8-17 ? * SUN,MON,TUE,WED,THU *',
		types: {
			'ONCE': ['days', 'hours', 'minutes', 'type'],
			'INTERVAL': ['days', 'hoursBegin', 'hoursEnd', 'minutesPeriod', 'type'],
			'RAW': ['expression', 'type']
		},
		nextLaunch: '',
		error: '',
	}
}

function getNotification () {
	return window.manager.notification.cronExpression || null
}

export default {
	name: 'NotificationModal',
	data () {
		return {
			...initialState(),
			type: 'ONCE',
			periodically: 'minutes',
			users: [],
			selectedUsers: [],
			selectedGroups: [],
			templates: [],
			templateId: null,
			htmlPreview: '',
			preloader: false,
			multicheckboxSelector: '.multicheckbox-filter'
		}
	},
	props: [
		'companyId'
	],
	computed: {
		groups: function () {
			let vm = this
			let groups =  this.$store.getters.getGroups.map(group => {
				if (vm.selectedGroups.includes(group.id)) {
					group.checked = true
					group.class = 'active-item'
				}

				return group
			})

			return this.sort(groups, 'name')
		},
		action: function () {
			return window.manager.action
		},
		defaultTypePeriodTab: function () {
			if (this.action === 'create') {
				return 'ONCE'
			} else {
				let notification = getNotification()
				return notification.type
			}
		}
	},
	watch: {
		type: async function (newValue, prevValue) {
			if (newValue !== prevValue) {
				await this.cronExpressionHandler()
			}
		}
	},
	async mounted () {
		let vm = this
		let manager = window.manager
		let notification = getNotification()
		if (notification) {
			let notification = getNotification()
			Object.assign(vm.$data, notification)
			vm.$set(vm, 'type', notification.type)
		}

		await vm.cronExpressionHandler()

		if (vm.action === 'edit') {
			vm.templateId = manager.notification.templateId
		}

		await Swal.fire({
			title: vm.action === 'edit' ? vm.$t('edit.email.notification') : vm.$t('new.email.notification'),
			html: vm.$el,
			confirmButtonText: vm.$t('save'),
			showCancelButton: true,
			cancelButtonText: vm.$t('cancel'),
			buttonsStyling: false,
			allowOutsideClick: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				popup: 'button-actions',
				content: 'form ',
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small'
			},
			onBeforeOpen: function () {
				let id = manager.notification.id
				if (vm.action === 'edit') {
					enableMulticheckboxSupport({
						selector: vm.multicheckboxSelector,
						selectAllCallback: function (name) {
							let selectedFeild = name === 'users' ? 'selectedUsers' : 'selectedGroups'
							vm.selectAll(selectedFeild, name)
						},
						clearCallback: function (name) {
							let selectedFeild = name === 'users' ? 'selectedUsers' : 'selectedGroups'
							vm[selectedFeild] = []
						}
					})
					$.ajax({
						type: 'GET',
						url: window.urlContext + `notification/${id}/users`,
						async: false,

						success: function (data) {
							if (data) {
								vm.selectedUsers = data
							}
							$.ajax({
								type: 'POST',
								url: window.urlContext + '/users?companyId=' + manager.companyId,
								async: false,

								success: function (data) {
									let users = data.map(user => {
										if (vm.selectedUsers.includes(user.id)) {
											user.checked = true
											user.class = 'active-item'
										}

										return user
									})
									vm.users = vm.sort(users, 'login')
								}
							})
						}
					})

					$.ajax({
						type: 'GET',
						url: window.urlContext + `notification/${id}/groups`,
						async: false,

						success: function (data) {
							if (data) {
								vm.selectedGroups = data
							}
							vm.$store.dispatch(USER_GROUP, manager.companyId)
						}
					})
				}

				$.ajax({
					type: 'POST',
					url: window.urlContext + 'company/templates',
					data: {
						id: manager.companyId
					},
					async: false,

					success: function (data) {
						if (data) {
							vm.templates = data
						}
					}
				})
			},
			onRender: function () {
				manager.initPage()
				vm.$emit('open-modal')
				if (vm.action === 'create') {
					setTimeout(() => {
						showMessageAlert(vm.$t('notification.create.information'), 'primary')
					}, 1000)
				}
			},
			onClose: function () {
				vm.$emit('close-modal')
				manager.resetFields()
			},
			preConfirm: function () {
				let notificationInformationData = manager.getNotificationInformation()

				if (!notificationInformationData.templateId) {
					Swal.showValidationMessage(getLocalizedMessage('template.is.empty'))
					return false
				}

				if (notificationInformationData.event !== 'ITEMS_CREATED') {
					notificationInformationData.cronExpression = vm.getCronExpression()
				}
				return notificationInformationData
			}
		}).then(function (result) {
			if (result.value && !vm.error) {
				if (vm.action === 'edit') {
					let id = manager.notification.id

					$.ajax({
						type: 'POST',
						url: window.urlContext + `notification/${id}/users`,
						data: {
							ids: JSON.stringify(vm.selectedUsers),
							notificationId: id
						},
						async: false,

						success: function () {
							vm.selectedUsers = []
						},
						error: function (error) {
							showMessageAlert('error', 'danger', error.message)
						}
					})

					$.ajax({
						type: 'POST',
						url: window.urlContext + `notification/${id}/groups`,
						data: {
							ids: JSON.stringify(vm.selectedGroups),
							notificationId: id
						},
						async: false,

						success: function () {
							vm.selectedGroups = []
						},
						error: function (error) {
							showMessageAlert('error', 'danger', error.message)
						}
					})
				}

				manager.saveNotification(result.value)
			}
		})

	},
	methods: {
		setType: function (type) {
			this.type = type
			if (!getNotification()) {
				this.resetData()
			} else {
				this.cronExpressionHandler()
			}
		},
		resetData: function () {
			Object.assign(this.$data, initialState())
		},
		getCronExpression: function () {
			let vm = this
			let cronExpression = {}
			this.types[this.type].forEach(function (value) {
				cronExpression[value] = vm[value]
			})
			return JSON.parse(JSON.stringify(cronExpression))
		},
		cronExpressionHandler: _.debounce(function () {
			let vm = this
			let cronExpression = this.getCronExpression()
			$.ajax({
				url: window.urlContext + 'scheduler/nextCronFireTime',
				type: 'GET',
				async: true,
				data: { cronExpression: JSON.stringify(cronExpression) },
				success: function (data) {
					vm.nextLaunch = vm.$t('next.launch') + ' ' + getFormattedDateTime(new Date(parseInt(data)))
					vm.error = ''
				},
				statusCode: {
					400: function () {
						vm.error = vm.$t('event.cron.expression.is.invalid')
						vm.nextLaunch = ''
					},
					500: function () {
						vm.error = vm.$t('error')
						vm.nextLaunch = ''
					}
				}
			})
		}, 500),
		setMulicheckboxValues: function (id, name) {
			let data = this[name]
			if (data.filter(item => item === id).length > 0) {
				data.splice(data.indexOf(id), 1)
			} else {
				data.push(id)
			}
			this[name] = data
		},
		generateValueList: function (data) {
			let list = ''
			data.forEach(function (item) {
				if (item.checked) {
					list += (item.login || item.name) + ', '
				}
			})
			return list
		},
		selectAll: function (selectField, dataField) {
			let values = []

			this[dataField].map(item => {
				values.push(item.id)
			})

			this[selectField] = values
		},
		resetMulticheckbox: function (name) {
			this.$refs[name].querySelector('.checkbox-list').style.display = 'block'
			this.$refs[name].querySelector('.checkbox-sublist').style.display = 'none'
		},
		getPreview: async function () {
			let vm = this
			vm.preloader = true

			http.post('/items/ids', {}, {}).then(response => {
				let ids = response.data.slice(0, 10)

				http.post('/template/get', {}, {
					params: {
						id: vm.templateId
					}
				}).then(function (template) {
					http.post('/template/preview', {
						'itemIds': ids,
						'template': template.data.htmlMessageTemplate
					}, {})
						.then(response => {
							vm.htmlPreview = response.data
							vm.preloader = false
						})
				})
			})
		},
		sort: function (array, key) {
			return array.filter(attr => attr.hasOwnProperty(key)).sort((a, b) => {
				let fa = a[key].toLowerCase(),
					fb = b[key].toLowerCase();

				if (fa < fb) {
					return -1;
				}
				if (fa > fb) {
					return 1;
				}
				return 0;
			})
		},
		resetPreview: function () {
			this.htmlPreview = ''
		}
	}
}
</script>

<style scoped lang="scss">
.label-radio {
	vertical-align: middle;
	margin-left: 5px;
}

.days-item label {
	margin-left: 5px;
	vertical-align: middle;
	font-weight: normal;
}

.once-wrapper, .interval-expression, .interval-wrapper, .raw-wrapper {
	margin-bottom: 10px;
}

.periodically-expression label, .interval-expression label, .periodically-expression input, .once-expression label, .once-expression input {
	display: block;
	margin-top: 5px;
}

.once-expression input, .periodically-expression input {
	border: 1px solid #cccccc;
	width: 100%;
}

.modal_item input:focus {
	outline: none;
}

.periodically-expression input[type="radio"] {
	margin: 4px;
	width: auto;
	position: absolute;
}

.periodically-expression input[type="number"] {
	width: 95%;
	margin: 0 0 0 auto;
}

@media (max-width: 576px) {
	.periodically-expression input[type="number"] {
		width: 92%;
	}
}

.once-expression input[type=number], .interval-expression input[type=number], .interval-expression select {
	width: 50px;
}

.expression {
	display: inline-block;
	margin-right: 10px;
}

.interval-expression span {
	display: inline;
	margin: 0 5px;
}

.interval-expression span:first-child {
	margin-left: 0;
}

.interval-expression span:last-child {
	margin-right: 0;
}

.interval-expression input, .interval-expression select {
	border: 1px solid #cccccc;
}

.interval-expression select {
	outline: none;
}

.days-wrapper {
	margin-bottom: 15px;
}

.cron-expression-wrapper {
	padding: 5px;
}

.modal_item .once-expression span {
	margin-top: 5px;
	display: block;
}

.modal_item .success {
	color: #0f9d58;
	font-weight: bold;
}

.modal_item .error {
	color: #f0506e;
}

.modal_item .error, .modal_item .success {
	margin-left: 5px;
}

#schedulerTab {
	display: none;
}

.multicheckbox-filter {
	display: flex;
}

.multicheckbox-filter .mcb-drop-down-btn {
	z-index: 139;
	width: 30px;
}

.multicheckbox-filter .value-list {
	font-size: 14px;
	line-height: 17px;
}

.mcb-item-list {
	width: 300px;
}

.checkbox-list {
	display: flex;
	flex-direction: column;
}

.preview_frame {
	background: transparent;
}
.preview_info {
	text-align: left;
	font-size: 14px;
}
.iframe {
	z-index: -2;
}
.spinner-border {
	display: inline-block;
	position: absolute;
	top: 5px;
	right: -22px;
	width: 15px;
	height: 15px;
	vertical-align: text-bottom;
	border: .25em solid #ececec;
	border-right-color: transparent;
	border-radius: 50%;
	-webkit-animation: spin .75s linear infinite;
	animation: spin .75s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
